import { render, staticRenderFns } from "./update-stockorder-status.vue?vue&type=template&id=31e6c721"
import script from "./update-stockorder-status.vue?vue&type=script&lang=ts"
export * from "./update-stockorder-status.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports